module.exports = __webpack_public_path__ + "30f1ff60826e8e5fc9ef7f0de3793328.png";